/** Shared gray-900 shell + atmosphere + glass panels (QR check-in, staff dashboard, etc.) */

/** Raw shell background. Keep in sync with the `bg-[...]` in SITE_PAGE_SHELL_CLASS -
 *  needed by surfaces that sit in flow above the shell and must match it exactly. */
export const SITE_PAGE_SHELL_BG = "#0B0E34";

export const SITE_PAGE_SHELL_CLASS =
  "relative min-h-screen bg-[#0B0E34] text-white overflow-x-hidden";

export const GLASS_PANEL_CLASS =
  "rounded-xl md:rounded-2xl border border-white/[0.08] bg-white/[0.03] backdrop-blur-md shadow-none";

/** Top inset before eyebrow, aligns with About / Sponsorship (`p-8` + section `py-20`). */
export const SITE_PAGE_BODY_PADDING_TOP =
  "pt-[max(7rem,calc(env(safe-area-inset-top,0px)+5.5rem))]";

export function SitePageAtmosphere() {
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden
    >
      <div
        className="absolute inset-0 opacity-[0.45]"
        style={{
          backgroundImage: [
            "radial-gradient(ellipse 120% 80% at 50% -30%, rgba(0,212,255,0.12) 0%, transparent 55%)",
            "radial-gradient(ellipse 70% 50% at 100% 40%, rgba(244,114,182,0.06) 0%, transparent 50%)",
            "radial-gradient(ellipse 60% 45% at 0% 70%, rgba(0,212,255,0.05) 0%, transparent 45%)",
          ].join(", "),
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.55]"
        style={{
          backgroundImage: [
            "radial-gradient(1px 1px at 18% 22%, rgba(255,255,255,0.4) 50%, transparent 100%)",
            "radial-gradient(1px 1px at 62% 18%, rgba(0,212,255,0.45) 50%, transparent 100%)",
            "radial-gradient(1px 1px at 88% 44%, rgba(244,114,182,0.35) 50%, transparent 100%)",
            "radial-gradient(1.5px 1.5px at 12% 78%, rgba(250,204,21,0.3) 50%, transparent 100%)",
            "radial-gradient(1px 1px at 44% 91%, rgba(255,255,255,0.25) 50%, transparent 100%)",
          ].join(", "),
          backgroundSize: "100% 100%",
        }}
      />
    </div>
  );
}
